<template>
    <div class="c-dashboard-row -week"
        :data-component-name="$options.name"
    >
        <div
            v-if="draftShifts.length || shifts.length"
            class="c-dashboard__item -control -left"
        >
            <button class="c-dashboard-control -expand-row" v-if="maxAssignmentsCount>5" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')" >
                <SvgIcon name="arrow-down" />
            </button>
        </div>
        <div
            v-if="draftShifts.length || shifts.length"
            class="c-dashboard__item -week"
        >

            <!-- shifts -->
            <!-- <pre>{{weekdays}}</pre> -->
            <div class="c-dashboard-day__wrap is-linked-next"
                v-bind:key="index" v-for="(weekday, index) in weekdays"
                :class="{ 'weekend' : weekday.dayOfWeek==0 || weekday.dayOfWeek==6 }"
            >
            <!-- <pre>{{weekday}}</pre> -->

                <div class="o-assignment -prev" v-if="weekday.prevShift && weekday.shifts.length==0">
                    <button class="o-assignment-button"
                        @click="$emit('set-current-date', weekday.prevShift.date)"
                    >
                        <span class="o-assignment__text">Affectation précédente</span>
                        <span class="o-assignment__arrow">
                            <SvgIcon name="arrow-alt-left" />
                            <span class="o-assignment__arrow__line"></span>
                        </span>
                        <span class="o-assignment__date">{{ weekday.prevShift.dateStr }}</span>
                    </button>
                </div>
                <div class="o-assignment -next" v-if="weekday.nextShift && weekday.shifts.length==0">
                    <button class="o-assignment-button"
                        @click="$emit('set-current-date', weekday.nextShift.date)"
                    >
                        <span class="o-assignment__text">Affectation suivante</span>
                        <span class="o-assignment__arrow">
                            <SvgIcon name="arrow-alt-left" />
                            <span class="o-assignment__arrow__line"></span>
                        </span>
                        <span class="o-assignment__date">{{ weekday.nextShift.dateStr }}</span>
                    </button>
                </div>

                <SvgIcon name="link" class="c-dashboard__link -link-next"
                    v-if="(
                        (weekday.shifts.length || weekday.prevShift) && (!weekday.isLastDate) ||
                        (weekday.shifts.length==0 && weekdays[index+1] && weekdays[index+1].shifts.length  && (!weekday.isFirstDate))
                    )"
                />
                <Shift
                    :showHeaders="showHeaders"
                    :headerDate="weekday.dateStr"
                    v-bind:shifts="weekday.shifts"
                    v-bind:shiftsView="shiftsView"
                    @create-shift-override="$emit('create-shift-override', $event)"
                    @refresh-project="$emit('refresh-project', $event)"
                />

            </div>
            <!-- /shifts -->
        </div>


        <div
            v-if="draftShifts.length || shifts.length"
            class="c-dashboard__item -control -right"
        >
            <button class="c-dashboard-control -expand-row" v-if="maxAssignmentsCount>5"  @click="e => e.target.closest('.c-dashboard-row.-week').classList.toggle('is-expanded')" >
                <SvgIcon name="arrow-down" />
            </button>
        </div>

    </div>
</template>

<script>
    import {getDatesBetween, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import moment from 'moment';
    import Shift from "@/components/projects/Shift"

    export default {

        name: "Shifts",
        props: {
            showHeaders: {
                type: Boolean,
                default: false,
            },
            shifts: {
                type: Array,
                default: function(){
                    return new Array()
                }
            },
            draftShifts: {
                type: Array,
                default: function(){
                    return new Array()
                }
            },
            currentDate: String,
            weekrange: Object,
            prevShift: String,
            nextShift: String,
            shiftsView: {
                type: String,
                default: 'profession'
            }
        },
        components: {
            Shift
        },
        data(){
            return{
                // maxAssignmentsCount: 0
            }
        },
        mounted(){
        },
        computed: {
            maxAssignmentsCount(){
                let maxAssignmentsCount=0;
                this.weekdays.forEach(function(weekday){
                    weekday.shifts.forEach(function(shift){
                        if(this.shiftsView=="man"){
                            if(shift.assignments.length>maxAssignmentsCount) maxAssignmentsCount=shift.assignments.length;
                        }else{
                            if(shift.professionList && Object.keys(shift.professionList).length>maxAssignmentsCount) maxAssignmentsCount=Object.keys(shift.professionList).length;
                        }
                    }.bind(this))
                }.bind(this))
                return maxAssignmentsCount;
            },
            prevShiftStr(){
                if(!this.prevShift) return this.prevShift
                let date=new Date(this.prevShift)
                return date.getDate()+' '+ monthStr(date).full.toLowerCase()+' '+date.getFullYear()
            },
            nextShiftStr(){
                if(!this.nextShift) return this.nextShift
                let date=new Date(this.nextShift)
                return date.getDate()+' '+ monthStr(date).full.toLowerCase()+' '+date.getFullYear()
            },
            fromStr(){
                return this.weekrange.obj.from.getDate()+' '+ monthStr(this.weekrange.obj.from).full.toLowerCase()+' '+this.weekrange.obj.from.getFullYear()
            },
            toStr(){
                return this.weekrange.obj.to.getDate()+' '+ monthStr(this.weekrange.obj.to).full.toLowerCase()+' '+this.weekrange.obj.to.getFullYear()
            },
            weekdays(){
                let dateRange=getDatesBetween(this.weekrange.obj.from, this.weekrange.obj.to)
                let weekdays=[]
                let gotShifts=false, firstShift=null;
                let lastShift=null;

                // shiftsList=this.resolveShiftsList(this.shifts, this.draftShifts);

                dateRange.forEach(function(date, index){
                    let dateStr=moment(date).format('YYYY-MM-DD');
                    let shifts=this.shifts.filter(function(e){
                        return e.date==dateStr;
                    })
                    let draftShifts=this.draftShifts.filter(function(e){
                        return e.date==dateStr;
                    })

                    let shiftsList=this.resolveShiftsList(shifts, draftShifts);

                    let isFirstDay = index==0;
                    let isLastDay = index==dateRange.length-1;

                    if(shiftsList.length==0 && !gotShifts){
                        firstShift=index;
                    }else{
                        gotShifts=true;
                    }
                    if(shiftsList.length==0 && !lastShift){
                        lastShift=index
                    }else if(shiftsList.length>0){
                        lastShift=null
                    }
                    weekdays.push({
                        date: date,
                        day: dayStr(date.getDate()),
                        dayOfWeekStr: dayOfWeekStr(date),
                        dayOfWeek: date.getDay(),
                        monthStr: monthStr(date),
                        dateStr: '<span class="-dayofweek">' + dayOfWeekStr(date).full + " </span> " + dayStr(date.getDate()) + " " + monthStr(date).full.toLowerCase(),
                        shifts: shiftsList,
                        isFirstDay: isFirstDay,
                        isLastDay: isLastDay,
                        isLastDate: false,
                        isFirstDate: false,
                        prevShift: null,
                        nextShift: null,
                    })
                }.bind(this))

                if(firstShift == null) firstShift=0;
                if(this.prevShift){
                    let date=new Date(moment(this.prevShift));
                    let dateStr=date.getDate()+" "+monthStr(date).full.toLowerCase()+" "+date.getFullYear();

                    weekdays[firstShift].prevShift={
                        date: this.prevShift,
                        dateStr: dateStr
                    }
                }else{
                    if(weekdays[firstShift]) weekdays[firstShift].isFirstDate=true
                }

                if(lastShift == null) lastShift=dateRange.length-1;
                if(this.nextShift){
                    let date=new Date(moment(this.nextShift));
                    let dateStr=date.getDate()+" "+monthStr(date).full.toLowerCase()+" "+date.getFullYear();
                    weekdays[lastShift].nextShift={
                        date: this.nextShift,
                        dateStr: dateStr
                    }
                }else{
                    if(weekdays[lastShift-1]) weekdays[lastShift-1].isLastDate=true
                }
                return weekdays
            },
        },
        methods: {
            resolveShiftsList(shifts, draftShifts) {
                if(shifts.length==0 && draftShifts.length>0) return draftShifts;
                if(draftShifts.length==0) return shifts;

                let shiftsList=Object.assign([], shifts);

                draftShifts.forEach(function(draftShift){
                    if(shifts.filter(s => s["draft_shift_id"] == draftShift.id).length==0){
                        shiftsList.push(draftShift);
                    }
                })

                return shiftsList;
            },
            // getMaxAssignmentsCount(shiftsList){
            //     // let tmpList=JSON.parse(JSON.stringify(shiftsList))
            //     // shiftsList.forEach(function(list){
            //     //     if(list.assignments.count>0){
            //     //         this.maxAssignmentsCount=list.assignments.count
            //     //     }
            //     // }.bind(this))
            // }
        }
    }
</script>
